// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/**
 * listener: EventBus.on("unique event key", customEvent); // customEvent is a function
 * dispatch: EventBus.dispatch("unique event key", data);
 * remove:   EventBus.remove("unique event key", customEvent);
 *     function customEvent(e: any) {
 *       console.log(e.detail); // you will find data inside e.detail
 *  }
 * */

const EventBus = {
    on(event: any, callback: any) {
        typeof document !== "undefined" && document.addEventListener(event, callback);
    },
    dispatch(event: any, data: any) {
        typeof document !== "undefined" && document.dispatchEvent(new CustomEvent(event, { detail: data }));
    },
    remove(event: any, callback?: any) {
        typeof document !== "undefined" && document.removeEventListener(event, callback);
    },
};

export default EventBus;
